import React from 'react';

import * as styles from './styles/styles.module.scss';
import { wrapEventHandler } from '../../../utils/handlers';

export default function AddRemoveButton({ isInCollection, addLabel, removeLabel, handleClick, className }) {
  const label = isInCollection ? removeLabel : addLabel;
  return (
    <span title={label} className={`clickable ${className} ${isInCollection ? styles.remove : styles.add}`} onClick={wrapEventHandler(handleClick)} />
  );
}
